import { RepeatIcon, SettingsIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Grid, Text } from "@chakra-ui/react";
import {
  bgError,
  bgInfo,
  bgSucess,
  StatusFormat,
} from "components/dynamic-table/row-status";
import { SkeletonLoading } from "components/skeleton-loading";
import { useApplicationContext } from "contexts/ApplicationContext";
import { SelectedCustomer } from "pages/carteira";
import { Dispatch, SetStateAction } from "react";
import { useRouter } from "routes/router-control/use-router";
import { PriceButton } from ".";
import { PhoneIcon } from "components/vectors/phone-icon";
import { ServicesProps } from "pages/servicos/types";

export function VendeAICard({
  isLoading,
  priceDesc,
  title,
  serviceData,
  selectedCustomer,
  setCardData,
}: {
  isLoading?: boolean;
  title: string;
  priceDesc: string;
  serviceData: Partial<ServicesProps>;
  selectedCustomer: SelectedCustomer;
  setCardData: Dispatch<SetStateAction<Partial<ServicesProps>>>;
}) {
  const { user } = useApplicationContext();
  const router = useRouter();
  const isSelectedLoggedCustomer =
    user.userData.customerId === selectedCustomer.id;
  let statusCode = serviceData.vendeAI?.statusCode;
  const isActive: boolean = ["active", "free_trial"].includes(statusCode!);
  const isShowButtonsConfigIA = isSelectedLoggedCustomer && isActive;

  const submitConfiguracao = () => {
    router.push(`/vende-ai`);
  };

  const px = "25px";
  const cardData = serviceData?.["vendeAI"];

  const titleContainerHeight = "80px";

  const statusCodeData = new Map([
    [
      "does_not_exist",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Ativar",
        status: "Inativo",
        color: bgError,
      },
    ],
    [
      "pending_activation",
      {
        url: serviceData.vendeAI?.detailsOnboardingLink,
        desc: "Marcar Onboarding",
        status: "Pendente de ativação",
        color: bgError,
      },
    ],
    [
      "free_trial",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Trial Gratuito",
        color: bgInfo,
      },
    ],
    [
      "active",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Ativo",
        color: bgSucess,
      },
    ],
    [
      "inactive",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Inativo",
        color: bgError,
      },
    ],
    [
      "cancelled",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Cancelado",
        color: bgError,
      },
    ],
  ]);

  return (
    <SkeletonLoading
      isLoading={!!isLoading}
      borderRadius="5px"
      bg="#fff"
      overflow="hidden"
    >
      <Flex
        justifyContent="space-between"
        flexDir="column"
        bg="#fff"
        borderRadius="5px"
        overflow="hidden"
        h="100%"
        border="1px solid var(--chakra-colors-custom-gray)"
      >
        <Flex
          px={px}
          w="100%"
          h={titleContainerHeight}
          alignItems="center"
          pos="relative"
          overflow="hidden"
          justifyContent="flex-start"
        >
          <Text
            fontSize={{ base: "18px", "2xl": "20px" }}
            fontWeight="semibold"
          >
            {title}
          </Text>
        </Flex>
        <Flex flexDir="column" px={px} py="15px" minH="215px">
          <Grid
            templateColumns="70px auto"
            gap="10px"
            alignItems="center"
            w="100%"
            mb="10px"
          >
            <Text fontWeight="semibold">Status:</Text>
            <Grid gap="10px">
              <StatusFormat
                w="100%"
                bg={statusCodeData.get(statusCode ?? "")?.color}
              >
                {statusCodeData.get(statusCode ?? "")?.status}
              </StatusFormat>
              {statusCodeData.get(statusCode ?? "")?.desc ? (
                <Button
                  leftIcon={<RepeatIcon w="13px" h="13px" />}
                  variant={"outline"}
                  size="xs"
                  as="a"
                  target="_blank"
                  href={statusCodeData.get(statusCode ?? "")?.url}
                >
                  {statusCodeData.get(statusCode ?? "")?.desc}
                </Button>
              ) : null}
            </Grid>
          </Grid>{" "}
          <Box w="100%" mt="10px">
            {isShowButtonsConfigIA ? (
              <>
                <Button
                  mt="10px"
                  mb="8px"
                  w="100%"
                  size="sm"
                  variant="outline"
                  bg="#fff"
                  leftIcon={<SettingsIcon />}
                  onClick={submitConfiguracao}
                >
                  Configurar Inteligência Artificial
                </Button>

                <Button
                  as="a"
                  href="https://wa.me/17997479430"
                  target="_blank"
                  mb="10px"
                  w="100%"
                  size="sm"
                  variant="outline"
                  bg="#fff"
                  leftIcon={<SettingsIcon />}
                >
                  Configurar WhatsApp Oficial
                </Button>
              </>
            ) : null}
            <Button
              as="a"
              href="https://wa.me/17997479430"
              target="_blank"
              mb="10px"
              w="100%"
              size="sm"
              variant="outline"
              bg="#fff"
              leftIcon={<PhoneIcon width="16px" height="16px" />}
            >
              Falar com o Suporte Vende AI
            </Button>
          </Box>
        </Flex>
        <Box px={px} pb="15px" mt="auto">
          <PriceButton>{priceDesc}</PriceButton>
        </Box>
      </Flex>
    </SkeletonLoading>
  );
}
